//
// Anchor Tab #DABB-55
//

let urlHash = document.location.hash.replace('#', '');

if (urlHash) {
    let urlTabContentID = urlHash;

    let urlTabID = urlHash + '-tab';

    if (document.getElementById(urlTabID)) {
        var tabElementID = document.getElementById(urlTabID).parentNode.parentNode.id;

        var tabElement = document.getElementById(tabElementID);
    }

    if (typeof (tabElement) != 'undefined' && tabElement != null) {
        for (let i = 0; i < tabElement.children.length; i++) {

            let curElementID = tabElement.children[i].children[0].id;

            let curElement = document.getElementById(curElementID);

            let curContentID = curElement.getAttribute('aria-controls');

            if (curContentID === urlTabContentID) {
                curElement.classList.add('active');
                curElement.setAttribute('aria-selected', 'true');

                document.getElementById(curContentID).classList.add('show');
                document.getElementById(curContentID).classList.add('active');
            } else {
                curElement.classList.remove('active');
                curElement.setAttribute('aria-selected', 'false');

                document.getElementById(curContentID).classList.remove('show');
                document.getElementById(curContentID).classList.remove('active');
            }
        }
        
        tabElement.scrollIntoView();
    }
}

let navLink = document.querySelectorAll('.nav-link');

navLink.forEach(function (tab) {
    tab.addEventListener("click", function () {
        let anchor = tab.getAttribute('href');

        let wlocation = window.location + "";

        let pos = wlocation.lastIndexOf('#');

        wlocation = wlocation.substr(0, pos);
        window.location.replace(wlocation+anchor);
    });
});

export default {};
